export default __webpack_public_path__ + "static/media/image.711040a6.svg";